export enum SessionStorageKey {
  AccessToken = "accessToken",
}
